import { AddOutlined, BlockOutlined, CategoryOutlined, CheckCircleOutlined, DashboardOutlined, Inventory2Outlined, ListAltOutlined, PendingActionsOutlined, SettingsOutlined, TuneOutlined, PhotoLibraryOutlined } from "@mui/icons-material";
import AddCategory from "./Categories/AddCategory";
import CategoriesManagementPage from "./Categories/CategoriesManagementPage";
import UpdateCategory from "./Categories/UpdateCategory";
import AddProduct from "./Products/AddProduct";
import ProductsManagementPage from "./Products/ProductsManagementPage";
import UpdateProduct from "./Products/UpdateProduct";
import AddProject from "./Projects/AddProject";
import ProjectsManagementPage from "./Projects/ProjectsManagementPage";
import UpdateProject from "./Projects/UpdateProject";
import AddSpecificationCategory from "./SpecificationCategories/AddSpecificationCategory";
import SpecificationCategoriesManagementPage from "./SpecificationCategories/SpecificationCategoriesManagementPage";
import UpdateSpecificationCategory from "./SpecificationCategories/UpdateSpecificationCategory";
import AddSpecification from "./Specifications/AddSpecification";
import SpecificationsManagementPage from "./Specifications/SpecificationsManagementPage";
import UpdateSpecification from "./Specifications/UpdateSpecification";
import OrdersManagementPage from "./Orders/OrdersManagementPage";

export const path = "/manager";

const dashboardName = {
    type: "Localized",
    text: "application.name",
};

export const roles = [
    "normal"
];

export const dashboardConfig = {
    path: path,
    name: dashboardName,
    roles: roles,
    items: [
        {
            path: "dashboard",
            name: { type: "Internal", text: "dashboard" },
            icon: <DashboardOutlined />,
            hide: false,
            spec: { type: "Simple", object: <h1>Dashboard Coming Soon</h1> },
        },
        // {
        //     path: "orders",
        //     name: { type: "Localized", text: "common.orders" },
        //     icon: <ListAltOutlined />,
        //     hide: false,
        //     specs: [
        //         {
        //             path: "active",
        //             name: { type: "Localized", text: "common.activeOrders" },
        //             icon: <PendingActionsOutlined />,
        //             spec: {
        //                 type: "Simple",
        //                 object: (
        //                     <OrdersManagementPage
        //                         statuses={['pending', 'preparing', 'readyForDelivery', 'outForDelivery']}
        //                         title="הזמנות פעילות"
        //                         subtitle="הזמנות הממתינות לטיפול, בהכנה, מוכנות או בדרך"
        //                     />
        //                 ),
        //             },
        //         },
        //         {
        //             path: "delivered",
        //             name: { type: "Localized", text: "common.deliveredOrders" },
        //             icon: <CheckCircleOutlined />,
        //             spec: {
        //                 type: "Simple",
        //                 object: (
        //                     <OrdersManagementPage
        //                         statuses={['delivered']}
        //                         title="הזמנות שנמסרו"
        //                         subtitle="הזמנות שהושלמו ונמסרו ללקוח"
        //                     />
        //                 ),
        //             },
        //         },
        //         {
        //             path: "cancelled",
        //             name: { type: "Localized", text: "common.cancelledOrders" },
        //             icon: <BlockOutlined />,
        //             spec: {
        //                 type: "Simple",
        //                 object: (
        //                     <OrdersManagementPage
        //                         statuses={['cancelledByUser', 'cancelledByBusiness']}
        //                         title="הזמנות מבוטלות"
        //                         subtitle="הזמנות שבוטלו על ידי הלקוח או העסק"
        //                     />
        //                 ),
        //             },
        //         },
        //     ],
        // },
        {
            path: "categories",
            name: { type: "Localized", text: "common.categories" },
            icon: <CategoryOutlined />,
            hide: false,
            specs: [
                {
                    path: "add",
                    name: { type: "Localized", text: "common.addCategory" },
                    icon: <AddOutlined />,
                    spec: { type: "Simple", object: <AddCategory /> },
                },
                {
                    path: "update/:categoryId",
                    name: { type: "Localized", text: "common.updateCategory" },
                    icon: <CategoryOutlined />,
                    hide: true,
                    spec: { type: "Simple", object: <UpdateCategory /> },
                },
                {
                    path: "manage",
                    name: { type: "Localized", text: "common.manageCategories" },
                    icon: <CategoryOutlined />,
                    spec: { type: "Simple", object: <CategoriesManagementPage /> },
                },
            ],
        },
        {
            path: "products",
            name: { type: "Localized", text: "common.products" },
            icon: <Inventory2Outlined />,
            hide: false,
            specs: [
                {
                    path: "add",
                    name: { type: "Localized", text: "common.addProduct" },
                    icon: <AddOutlined />,
                    spec: { type: "Simple", object: <AddProduct /> },
                },
                {
                    path: "update/:productId",
                    name: { type: "Localized", text: "common.updateProduct" },
                    icon: <Inventory2Outlined />,
                    hide: true,
                    spec: { type: "Simple", object: <UpdateProduct /> },
                },
                {
                    path: "manage",
                    name: { type: "Localized", text: "common.products" },
                    icon: <Inventory2Outlined />,
                    spec: { type: "Simple", object: <ProductsManagementPage /> },
                },
            ],
        },
        {
            path: "projects",
            name: { type: "Localized", text: "common.projects" },
            icon: <PhotoLibraryOutlined />,
            hide: false,
            specs: [
                {
                    path: "add",
                    name: { type: "Localized", text: "common.addProject" },
                    icon: <AddOutlined />,
                    spec: { type: "Simple", object: <AddProject /> },
                },
                {
                    path: "update/:projectId",
                    name: { type: "Localized", text: "common.updateProject" },
                    icon: <PhotoLibraryOutlined />,
                    hide: true,
                    spec: { type: "Simple", object: <UpdateProject /> },
                },
                {
                    path: "manage",
                    name: { type: "Localized", text: "common.projects" },
                    icon: <PhotoLibraryOutlined />,
                    spec: { type: "Simple", object: <ProjectsManagementPage /> },
                },
            ],
        },
        {
            path: "specification-categories",
            name: { type: "Localized", text: "common.specificationCategories" },
            icon: <TuneOutlined />,
            hide: false,
            specs: [
                {
                    path: "add",
                    name: { type: "Localized", text: "common.addSpecificationCategory" },
                    icon: <AddOutlined />,
                    spec: { type: "Simple", object: <AddSpecificationCategory /> },
                },
                {
                    path: "update/:categoryId",
                    name: { type: "Localized", text: "common.updateSpecificationCategory" },
                    icon: <TuneOutlined />,
                    hide: true,
                    spec: { type: "Simple", object: <UpdateSpecificationCategory /> },
                },
                {
                    path: "manage",
                    name: { type: "Localized", text: "common.specificationCategories" },
                    icon: <TuneOutlined />,
                    spec: { type: "Simple", object: <SpecificationCategoriesManagementPage /> },
                },
            ],
        },
        {
            path: "specifications",
            name: { type: "Localized", text: "common.specifications" },
            icon: <SettingsOutlined />,
            hide: false,
            specs: [
                {
                    path: "add",
                    name: { type: "Localized", text: "common.addSpecification" },
                    icon: <AddOutlined />,
                    spec: { type: "Simple", object: <AddSpecification /> },
                },
                {
                    path: "update/:specificationId",
                    name: { type: "Localized", text: "common.updateSpecification" },
                    icon: <SettingsOutlined />,
                    hide: true,
                    spec: { type: "Simple", object: <UpdateSpecification /> },
                },
                {
                    path: "manage",
                    name: { type: "Localized", text: "common.specifications" },
                    icon: <SettingsOutlined />,
                    spec: { type: "Simple", object: <SpecificationsManagementPage /> },
                },
            ],
        },
    ],
};